import "../../App.scss";
import CTA from "../../components/CallToAction/CTA";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Intro from "../../components/Intro/Intro";
import Teams from "../../components/Teams/Teams";

const About = () => {
    return(
        <main className="about-page">
            <Header />
            <Intro />
            <Teams />
            <CTA />
            <Footer />
        </main>
    )
}

export default About;